import _ from "lodash";
import React from "react";
import classes from "./MoreItemWithToolTip.scss";
import PropTypes from "prop-types";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import I18nHOC from "UIComponents/I18nHOC";
import classNames from "classnames";
import { colors } from "Constants";
class _MoreItemWithToolTip extends React.Component {
  onContainerClick = e => {
    const { stopPropagationOnLabelClick } = this.props;
    if (stopPropagationOnLabelClick) e.stopPropagation();
  };
  getRenderComponent() {
    const {
      testId,
      items,
      length,
      noItemText,
      suffixText,
      moreStyle,
      tooltipPlacement,
      renderComponent,
      moreJoinSymbol,
      containerStyle,
      moreAll,
      onVisibleChange,
      joinSymbol,
      t,
      isAllSelected,
      allItemsText,
      trigger,
      maxLength,
      itemsTotalCount,
      renderMoreComponent,
      showDashOnNoItemText,
      emptyTextStyle = {},
      suffixTextStyle = {},
      closeOnScroll,
      tooltipContainerStyle,
      renderCompWithMoreItems,
      linkStyles,
      truncateLimit,
      tabIndex,
      overrideClasses = {},
      tooltipOverlayStyle,
      dir = "auto",
      onMouseEnter,
      onMouseLeave,
    } = this.props;
    let { valueStyle } = this.props;
    let valueString = "";
    let moreComponent = null;
    const allItemArray = [...items];
    const itemArray = allItemArray.slice(0, length);
    const itemsLength = _.get(items, "length", 0);

    const allItemsTextLocale =
      allItemsText == "all_label"
        ? t("common:all_label", { label: t("common:items") })
        : allItemsText;

    if (!renderComponent || !renderCompWithMoreItems) {
      const currentJoinSymbol = joinSymbol
        ? joinSymbol
        : items.length == length
        ? " & "
        : ", ";
      itemArray.map((item, i) => {
        valueString += item;
        valueString += i < itemArray.length - 1 ? currentJoinSymbol : "";
      });

      if (itemArray.length == 0) {
        valueStyle = {
          ...valueStyle,
          ...emptyTextStyle,
        };
        if (noItemText) {
          valueString = noItemText;
        } else if (showDashOnNoItemText) {
          valueString = "-";
        } else {
          valueString = "";
        }
      }
    }

    if (items.length > length) {
      let moreItemArray = [];

      if (moreAll) {
        if (maxLength) {
          moreItemArray = _.slice(allItemArray, 0, maxLength);
          const remainingCount = _.get(allItemArray, "length", 0) - maxLength;
          if (remainingCount > 0) {
            moreItemArray.push(
              t("common:and_label_more", {
                label: remainingCount,
              })
            );
          }
        } else moreItemArray = allItemArray;
      } else {
        moreItemArray = allItemArray.slice(length, items.length);
      }

      moreComponent = (
        <div className={classes.tootTipConainer}>
          {_.map(moreItemArray, (item, i) => {
            return (
              <div className={classes.moreToolTipItem} key={i}>
                {item}
                <br />
              </div>
            );
          })}
          {itemsTotalCount && itemsTotalCount > maxLength ? (
            <div className={classes.moreToolTipItem}>
              {`+ ${itemsTotalCount - maxLength} ${t("common:more")}`}
              <br />
            </div>
          ) : null}
        </div>
      );
    }
    const component = (
      <span
        className={classNames(classes.container, overrideClasses.container)}
        style={containerStyle}
        onClick={this.onContainerClick}
        dir={dir}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {renderCompWithMoreItems}
        {!renderComponent && !renderCompWithMoreItems && !isAllSelected && (
          <span style={valueStyle}>
            {truncateLimit && items.length > length
              ? _.truncate(valueString, { length: truncateLimit })
              : valueString}
          </span>
        )}
        {items.length > length ? (
          <LinkWithTooltip
            tooltip={renderMoreComponent ? renderMoreComponent : moreComponent}
            placement={tooltipPlacement}
            href="#"
            id="tooltip-dueDate"
            dataHtml={true}
            onVisibleChange={onVisibleChange}
            trigger={trigger}
            tooltipContainerStyle={tooltipContainerStyle}
            closeOnScroll={closeOnScroll}
            getTooltipContainer={this.props.getTooltipContainer}
            linkStyles={linkStyles}
            overlayStyle={tooltipOverlayStyle}
          >
            {!renderComponent && (
              <span
                className={classNames(
                  classes.moreContainer,
                  overrideClasses.moreContainer
                )}
                data-test-id={`${testId}-showTooltip-button`}
                style={moreStyle}
                key={"tooltip-dueDate"}
                tabIndex={tabIndex}
                dir="auto"
              >
                {isAllSelected
                  ? allItemsTextLocale
                  : t("common:number_more", {
                      number: `${moreJoinSymbol}${items.length - length}`,
                    })}
              </span>
            )}
            {renderComponent}
          </LinkWithTooltip>
        ) : null}
        {suffixText && (
          <span style={suffixTextStyle}>
            &nbsp;
            {suffixText}
          </span>
        )}
      </span>
    );

    return component;
  }

  render() {
    return this.getRenderComponent();
  }
}

_MoreItemWithToolTip.propTypes = {
  testId: PropTypes.string,
  items: PropTypes.array,
  length: PropTypes.number,
  noItemText: PropTypes.string,
  suffixText: PropTypes.string,
  moreStyle: PropTypes.object,
  valueStyle: PropTypes.object,
  tooltipPlacement: PropTypes.string,
  renderComponent: PropTypes.element,
  moreJoinSymbol: PropTypes.string,
  moreAll: PropTypes.bool,
  isAllSelected: PropTypes.bool,
  allItemsText: PropTypes.string,
  maxLength: PropTypes.number,
  itemsTotalCount: PropTypes.number,
  stopPropagationOnLabelClick: PropTypes.bool,
  showDashOnNoItemText: PropTypes.bool,
  tooltipContainerStyle: PropTypes.object,
  closeOnScroll: PropTypes.bool,
  renderCompWithMoreItems: PropTypes.element,
  truncateLimit: PropTypes.number,
  tabIndex: PropTypes.number,
};

_MoreItemWithToolTip.defaultProps = {
  testId: "UIComponents",
  items: [],
  length: 2,
  noItemText: "",
  suffixText: "",
  moreStyle: { color: colors.blue400, paddingLeft: "4px" },
  tooltipPlacement: "right",
  moreJoinSymbol: " +",
  moreAll: true,
  isAllSelected: false,
  allItemsText: "all_label",
  trigger: ["click", "focus"],
  valueStyle: {},
  itemsTotalCount: 0,
  stopPropagationOnLabelClick: true,
  showDashOnNoItemText: true,
  linkStyles: {},
  truncateLimit: 0,
  tabIndex: 0,
};
const MoreItemWithToolTip = React.memo(_MoreItemWithToolTip, _.isEqual);
MoreItemWithToolTip.displayName = "MoreItemWithToolTip";
export default I18nHOC({ resource: "common" })(MoreItemWithToolTip);
